import { render, staticRenderFns } from "./OwnOfferRandomStocksComponent.vue?vue&type=template&id=4312f056&"
import script from "./OwnOfferRandomStocksComponent.vue?vue&type=script&lang=js&"
export * from "./OwnOfferRandomStocksComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports